import React from "react";
import { DriveFileMoveOutlined as FolderIcon } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import { useGetMultiProjectQuery } from "fond/api";
import { EntityLabel, EntityType, Folder, MultiProject, Project, Report } from "fond/types";
import { IconNavLink } from "fond/widgets/Link/IconNavLink";

interface IProps {
  entity: Project | Report | MultiProject | Folder;
}

const getFolderId = (entity: IProps["entity"]): string | null | undefined => {
  switch (entity.EntityType) {
    case "project":
      return entity.FolderID;
    case "folder":
      // the "folder" for a folder is the parent folder.
      return entity.ParentID ?? entity.Parent?.ID;
    default:
      return entity.Folder?.ID;
  }
};

const ViewEntityFolderButton: React.FC<IProps> = ({ entity }) => {
  const entityType = entity.EntityType;
  const folderId = getFolderId(entity);
  const multiProjectId = entity.EntityType === "report" && entity.MultiProjectArea?.MultiProject?.ID ? entity.MultiProjectArea?.MultiProject?.ID : "";
  const { data: multiProject } = useGetMultiProjectQuery(multiProjectId, { skip: !multiProjectId });

  const getPath = () => {
    if (folderId) {
      if (entityType === "multi_project" || (entityType === "project" && entity.MultiProjectArea !== null)) {
        return `/cities/${folderId}`;
      } else if (entityType === "report" && entity.MultiProjectArea !== null && multiProject?.Folder?.ID) {
        return {
          pathname: `/cities/${multiProject?.Folder?.ID}`,
          search: new URLSearchParams({ multiReportFolderId: folderId }).toString(),
        };
      } else {
        return `/folders/${folderId}`;
      }
    } else {
      return "/workspace/";
    }
  };

  const getState = () => {
    if (entityType === "report" && entity.MultiProjectArea !== null && multiProject?.Folder?.ID) {
      return { tab: "report" };
    } else {
      return null;
    }
  };

  const entityTypeForLabel: EntityType = entityType === "folder" && entity.MultiProject ? "multi_project" : entityType;

  return (
    <Tooltip title={`Go to this ${EntityLabel[entityTypeForLabel]}'s folder`}>
      <IconNavLink to={getPath()} state={getState()} data-testid={`view-${entityType}-folder-btn`}>
        <FolderIcon fontSize="inherit" />
      </IconNavLink>
    </Tooltip>
  );
};

export default ViewEntityFolderButton;
